import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import FavoriteCard from "./FavoriteCard";

import "../../../styles/components/map/favorites/Favorites.scss";
import cross from "../../../styles/images/cross.svg";
import no_favorites from "../../../styles/images/no_favorites.svg";

class Favorites extends Component {
  render() {
    if (this.props.show)
      return (
        <div id="favorites">
          <button type="button" className="clear" onClick={this.props.onClose}>
            <img src={cross} alt="" />
          </button>
          <p className="title">
            <Translate value="mapFavorites_favorites" />
          </p>
          {this.props.favorites.length > 0 ? (
            <div className="favorites-container">
              {this.props.favorites.map(charger => (
                <FavoriteCard
                  key={charger._id}
                  charger={charger}
                  currentLocation={this.props.currentLocation}
                  toggleFavorite={this.props.toggleFavorite}
                />
              ))}
            </div>
          ) : (
            <div className="no-favorites">
              <img src={no_favorites} alt="" />
              <p className="no-favorites-title">
                <Translate value="mapFavorites_title" />
              </p>
              <p className="no-favorites-text">
                <Translate value="mapFavorites_text" />
              </p>
            </div>
          )}
        </div>
      );
    else return null;
  }
}

export default Favorites;
